import React from 'react';
import {MapControls, ReactLeafletMap} from "@gisatcz/ptr-maps";
import {HoverHandler} from "@gisatcz/ptr-core";
import RiskAssessmentMap from "./RiskAssessmentMap";
import InterferometryMap from "./InterferometryMap";
import LayersWrapper from "./LayersWrapper";

import Popup from "./Popup";

import './style.scss';

class MainMap extends React.PureComponent {
    render() {
        if (this.props.activeMapKey === "risk-assessment-big") {
            return this.renderMap(RiskAssessmentMap);
        } else if (this.props.activeMapKey === "interferometry-big") {
            return (
                <div className="eo4sdDrrInsarMyanmar20-main-map">
                    <InterferometryMap
                        mapComponent={ReactLeafletMap}
                        stateMapKey={this.props.activeMapKey}
                        wrapper={LayersWrapper}
                    >
                        <MapControls zoomOnly levelsBased/>
                    </InterferometryMap>
                </div>
            );
        } else {
            return null;
        }
    }

    renderMap(mapComponent) {
        return (
            <div className="eo4sdDrrInsarMyanmar20-main-map">
                <HoverHandler
                    popupContentComponent={React.createElement(Popup)}
                >
                    {React.createElement(mapComponent, {
                        mapComponent: ReactLeafletMap,
                        stateMapKey: this.props.activeMapKey,
                        wrapper: LayersWrapper
                    }, <MapControls zoomOnly levelsBased/>)}
                </HoverHandler>
            </div>
        );
    }
}

export default MainMap;
